<template>
  <article class="service">
    <div class="service-block">
      <div class="title">{{ title }}</div>
      <div class="service-menu">
        <div class="menu-title">
          <div class="list">
            <div
              :class="['service-menu-list', { active_menu: tabShow === index }]"
              v-for="(item, index) in list"
              :key="item.title"
              @click="tabShow = index"
            >
              {{ item.title }}
            </div>
            <div :class="['active_bor', `active_bor${tabShow}`]"></div>
          </div>
        </div>
        <div class="service-list" v-show="tabShow === index" v-for="(item, index) in list" :key="index">
          <div class="service-cont">
            <div class="left">
              <div class="service-title">{{ item.title }}</div>
              <div class="des">{{ item.des }}</div>
            </div>
            <img :src="item.img" :alt="item.title" />
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    title: String,
    list: Array,
  },
  data() {
    return {
      tabShow: 0,
    }
  },
  mounted() {
    setInterval(() => this.tabsChangs(), 10000)
  },
  methods: {
    // 10s自动切换tab
    tabsChangs() {
      const arr = [0, 1, 2]
      let i = arr.indexOf(this.tabShow)
      if (i === arr.length - 1) i = -1
      this.tabShow = arr[i + 1]
    },
  },
}
</script>

<style lang="less" scoped>
.service {
  width: 100%;
  background: #fff;
  padding: 80px 0;

  &-block {
    width: 1180px;
    margin: 0 auto;
  }

  .title {
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 40px;
    text-align: center;
  }

  &-menu {
    margin-top: 50px;

    .menu-title {
      border-bottom: 1px solid #eaeaea;
    }

    .list {
      display: flex;
      justify-content: center;
      position: relative;
    }

    .service-menu-list {
      width: 96px;
      margin-right: 140px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333;
      line-height: 22px;
      cursor: pointer;
      padding-bottom: 12px;

      &:nth-child(3) {
        margin-right: 0;
      }

      &:hover {
        color: #e61717;
        font-size: 16px;
      }

      &.active_menu {
        color: #e61717;
        font-size: 16px;
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }

    .active_bor {
      width: 96px;
      height: 3px;
      background: #e61717;
      position: absolute;
      bottom: 0;

      &0 {
        left: 306px;
        transition: left 0.3s;
      }

      &1 {
        left: 542px;
        transition: left 0.3s;
      }

      &2 {
        left: 778px;
        transition: left 0.3s;
      }
    }

    .service-cont {
      margin-top: 50px;
      display: flex;

      .left {
        padding-right: 90px;
      }

      .service-title {
        margin-top: 94px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        line-height: 40px;
      }

      .des {
        margin-top: 20px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        line-height: 24px;
      }

      img {
        width: 586px;
        height: 324px;
        border-radius: 3px;
      }
    }
  }
}
</style>
